import {sec} from "mathjs";
import * as ReactTimeout from 'react-timeout'

declare var Vimeo:any;

import {observer} from "mobx-react";
import * as React from "react";
import {API} from "api";

interface Props {
  videoId: string;
  bundleId: string;
  title: string;
}

@observer
export class WCEPVimeoPlayer extends React.Component<Props> {

  trimmedVideoId;
  timeoutId;
  player;

  constructor(props:Props) {
    super(props);
    this.timeoutId = null;
    const idx = this.props.videoId.indexOf("?");
    this.trimmedVideoId = -1!==idx ? this.props.videoId.substring(0,idx) : this.props.videoId;
  }

  handlePlay = () => {
    // clear out the old timeout if one exists
    this.handlePauseOrEnded();
    this.timeoutId = setTimeout(this.log, 15 * 1000);
  }

  log = () => {
    API.get(`/video-log/${this.props.bundleId}/${this.trimmedVideoId}`)
    .then(()=>{
      if(this.timeoutId) {
        this.timeoutId = setTimeout(this.log, 15 * 1000);
      }
    })
    .catch(()=>{
      if(this.timeoutId) {
        this.timeoutId = setTimeout(this.log, 15 * 1000);
      }
    });
  }

  handlePauseOrEnded = () => {
    if(this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  componentWillUnmount() {
    this.player.off('ended');
    this.player.off('pause');
    this.player.off('play');
    this.player = null;
    this.handlePauseOrEnded();
    // if(this.timeoutId) {
    //   clearTimeout(this.timeoutId);
    // }
  }

  componentDidMount() {
    this.player = new Vimeo.Player( document.querySelector('iframe') );
    this.player.on('play', this.handlePlay);
    this.player.on('ended',this.handlePauseOrEnded);
    this.player.on('pause',this.handlePauseOrEnded);
  }

  render() {
    return (
      // <Vimeo
      //   video={`https://player.vimeo.com/video/${this.props.videoId}`}
      //   autoplay
      //
      //   style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '360px'}}
      // />
      <>
      <iframe src={`https://player.vimeo.com/video/${this.props.videoId}`}
              frameBorder="0"
              allow="fullscreen"
              title={this.props.title}
              allowFullScreen
              style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '360px'}}></iframe>
      </>
    )
  }
}